import axios from 'axios';
import { Dispatch, useEffect } from 'react';
import { JobPublication } from '../types/job-publication';
import DataAction from '../../data/state/data-action';
import DataState from '../../data/state/data-state';
import Job, { createJob } from '../../jobs/types/job';
import ConfigState from '../../config/state/config-state';
import Config, { Data } from '../../config/types/config';

// @ts-ignore
const globalData = window.DvinciData?.jobPublications;

const initialize = (data: Data, dispatch: Dispatch<DataAction>) => {
  if (typeof data.url === 'undefined') {
    dispatch({ type: 'store-data', data: globalData || [] });
  } else {
    dispatch({ type: 'fetch-data', url: url(data).toString() });
  }
};

const refetch = (data: Data, dispatch: Dispatch<DataAction>): (() => void) => {
  return () => {
    const nextUrl = url(data);
    nextUrl.searchParams.append('_ti', String(Date.now()));
    dispatch({ type: 'fetch-data', url: nextUrl.toString() });
  };
};

const url = (data: Data): URL => {
  // eslint-disable-next-line compat/compat
  const dataUrl = new URL(data.url!, document.location.href);
  dataUrl.searchParams.append('language', data.language || 'en');
  dataUrl.searchParams.append('widget-version', 'v2');
  if (dataUrl.searchParams?.get('maxCacheAge') === '1') dataUrl.searchParams.set('maxCacheAge', '3600');
  if (data.maxCacheAge && !dataUrl.searchParams?.get('maxCacheAge'))
    dataUrl.searchParams.set('maxCacheAge', data.maxCacheAge);
  if (data.fieldsSmall && !dataUrl.searchParams?.get('fields')) dataUrl.searchParams.set('fields', 'small');
  return dataUrl;
};

const fetch = (config: Config, dispatch: Dispatch<DataAction>) => {
  let xDvinciWidgetConfig = '';
  try {
    xDvinciWidgetConfig = JSON.stringify({ l: window.location?.href, c: config });
  } catch {
    // ignore
  }
  const doFetch = async () => {
    try {
      const result = await axios({
        method: 'post',
        url: url(config.data).toString(),
        headers: { 'Content-Type': 'text/plain' },
        data: xDvinciWidgetConfig,
      });

      dispatch({ type: 'store-data', data: result.data });
    } catch (error: unknown) {
      dispatch({
        type: 'report-data-error',
        error: error instanceof Error ? error : TypeError(`Unknown error: ${error}`),
        retry: refetch(config.data, dispatch),
      });
    }
  };
  doFetch().then();
};

const process = (data: JobPublication[], dispatch: Dispatch<DataAction>) => {
  dispatch({
    type: 'process-data',
    jobs: data.map((value) => createJob(value)),
  });
};

const useDvinciApi = (config: ConfigState, data: DataState, dispatch: Dispatch<DataAction>): Job[] => {
  useEffect(() => {
    if (config.type === 'themed')
      switch (data.type) {
        case 'empty':
          initialize(config.config.data, dispatch);
          break;
        case 'loading':
          fetch(config.config, dispatch);
          break;
        case 'loaded':
          process(data.data, dispatch);
          break;
        default:
      }
  }, [config.type, data.type]);

  return data.type === 'processed' ? data.jobs : [];
};

export default useDvinciApi;
